"use strict";
exports.__esModule = true;
exports.synthesizeArray = void 0;
var synthesizeValue_1 = require("./synthesizeValue");
function synthesizeArray(schema, options) {
    var _a, _b, _c, _d, _e;
    var random = options.random;
    var minItems = (_b = (_a = schema.minItems) !== null && _a !== void 0 ? _a : options.minItems) !== null && _b !== void 0 ? _b : 1;
    var maxItems = (_d = (_c = schema.maxItems) !== null && _c !== void 0 ? _c : options.maxItems) !== null && _d !== void 0 ? _d : 3;
    var span = Math.max(maxItems - minItems, 0);
    var array = [];
    var length = minItems + span * random();
    for (var i = 0; i < length; i++) {
        array.push((0, synthesizeValue_1.synthesizeValue)((_e = schema.items) !== null && _e !== void 0 ? _e : {}, options));
    }
    return array;
}
exports.synthesizeArray = synthesizeArray;
